import { Flex } from "@chakra-ui/react";
import { FC } from "react";
import { Rw1LogoColored } from "../icons/RW1LogoColored";

export const LoadingPage: FC = () => {
  return (
    <Flex
      width={"100vw"}
      height={"100vh"}
      justifyContent={"center"}
      alignItems={"center"}
    >
      <Rw1LogoColored
        height={40}
        color={"text.1"}
      />
    </Flex>
  );
};
